import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/tutorial.svg'


const _withScopeId = n => (_pushScopeId("data-v-2268519a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tutorial p-d-flex" }
const _hoisted_2 = { class: "p-flex-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "category" }, "Campaign Participation: ", -1))
const _hoisted_4 = { class: "type" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tutorial-img",
    src: _imports_0
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-top":"5px","padding-left":"10px"} }, "PLAY", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "play_arrow", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString($props.item?.type), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString($props.item?.description), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("div", {
          class: "play-button p-d-flex",
          style: {"gap":"4px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.send && $setup.send(...args)))
        }, _hoisted_9)
      ])
    ])
  ]))
}